import { RenderLeafProps } from 'slate-react'

const RenderLeaf = ({
  attributes,
  children,
  leaf,
  isRenderParameter = true,
}: RenderLeafProps & { isRenderParameter?: boolean }) => {
  const isParameter = leaf.type === 'parameter' && isRenderParameter

  return (
    <span
      {...attributes}
      style={{
        ...(leaf.bold && { fontWeight: 'bold' }),
        ...(leaf.italic && { fontStyle: 'italic' }),
        ...(leaf.underline && { textDecoration: 'underline' }),
        ...(leaf.color && { color: `${leaf.color}` }),
        ...(leaf.fontSize && { fontSize: `${leaf.fontSize}px` }),
        ...(isParameter && { color: '#722ED1' }),
      }}
    >
      {children}
    </span>
  )
}

export default RenderLeaf
